<template>
    <span class="text-h4 font-weight-bold text-primary">
          {{ $t('app.name') }}
    </span>
</template>
<script setup lang="ts">

</script>
